import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { BucketShareByIdProtectedDocument } from '../../../graphql/generated' // Adjusted import
import logger from '../../../utils/logger'
import useAlerts from './useAlerts'

const useBucketShareByIdProtected = () => {
  const { shareId } = useParams<{ shareId: string }>()
  const { createAlert } = useAlerts()

  const { data, loading, refetch } = useQuery(BucketShareByIdProtectedDocument, {
    skip: !shareId,
    variables: { shareId: shareId ?? '' },
    onError: (error) => {
      if (error.graphQLErrors.length) {
        error.graphQLErrors.forEach((e) => {
          createAlert(e.message, 'error', e)
        })
      } else {
        createAlert('There was a problem retrieving your share. Please try again later.', 'error')
        logger.error('GraphQL Error:', error)
      }
    }
  })

  const shareProtectedDetails = {
    passwordProtected: data?.bucketShareById?.passwordProtected,
    password: data?.bucketShareById?.password,
    bucketId: data?.bucketShareById?.bucketId,
    id: data?.bucketShareById?.id,
    albumId: data?.bucketShareById?.albumId,
    shareStatus: data?.bucketShareById?.shareStatus
  }

  return {
    shareProtectedDetails,
    loading,
    refetch
  }
}

export default useBucketShareByIdProtected
